define('helperLayout-fixSvgTexts',[], function() {
    'use strict';

    var fixSvgTexts = function($svgSelection){
        // change font weight = 700 to 600 as it's better supported by Safari and Win 7 IE
        $svgSelection.each(function (svg) {
            var svgEl = window.Snap($svgSelection[svg]),
                weightAttrEls = svgEl.selectAll('[font-weight="700"]'),
                styleAttrEls = svgEl.selectAll('[style]');

            weightAttrEls.forEach(function (textEl) {
                textEl.node.setAttribute("font-weight", "600");
            });

            styleAttrEls.forEach(function (textEl) {
                var style = textEl.node.getAttribute("style");
                textEl.node.setAttribute("style", style.replace(/weight:(\s)?700/gi, "weight:600"));
            });});
    };

    return fixSvgTexts;
});

